// Homepage FAQ. Rendered visibly on the landing page AND emitted as FAQPage JSON-LD
// from the same array, so the structured data always matches what people can read.

export const FAQS = [
  {
    q: 'How does Cayda work?',
    a: 'Add your website URL, install one script tag (or use the WordPress plugin or Shopify app for a no code setup), and your team can click anywhere on the live page to leave notes. Each note is pinned to a specific element with an auto captured screenshot, browser info, and viewport data. Visitors never see it.',
  },
  {
    q: 'Is Cayda visible to website visitors?',
    a: 'No. Cayda is completely invisible to regular visitors. The feedback layer only appears for authenticated team members. No cookies, no tracking, no visible changes for your public audience.',
  },
  {
    q: 'What platforms does Cayda work with?',
    a: 'Cayda works with WordPress (one click plugin) and Shopify (native app) with no code required. It also supports Squarespace, Webflow, Wix, Next.js, React, Vue, and any static HTML site. The script handles single page apps, page transitions, and dynamic content automatically.',
  },
  {
    q: 'Does Cayda affect website performance?',
    a: 'The script loads asynchronously and only activates for authenticated team members. It adds no meaningful overhead for regular visitors and does not impact Core Web Vitals or page load times.',
  },
  {
    q: 'How much does Cayda cost?',
    a: 'Cayda is free for up to 2 websites, 50 notes per site, and 3 team members. Pro is $9/month base plus $5 per member (billed annually) for unlimited sites, notes, file attachments, and Slack integration. Team is $14/month base plus $6 per member (billed annually) and adds screen recording, guest access, and Jira, Asana, and Linear integrations. Monthly billing also available. No credit card required to start.',
  },
];

export const faqSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
});

export const softwareAppSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Cayda',
  url: 'https://www.cayda.io',
  description: 'Website feedback tool for teams. Click anywhere on your live site, leave a note — bugs, design feedback, content fixes. Invisible to visitors.',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  offers: [
    { '@type': 'Offer', price: '0', priceCurrency: 'USD', name: 'Free', description: '2 websites, 50 notes per site, 3 team members, 30-day history' },
    { '@type': 'Offer', price: '12', priceCurrency: 'USD', name: 'Pro', priceSpecification: { '@type': 'UnitPriceSpecification', price: '12', priceCurrency: 'USD', billingDuration: 'P1M', unitText: 'base + $6/member' }, description: 'Unlimited sites, notes, members, file attachments, Slack integration, invisible mode' },
    { '@type': 'Offer', price: '19', priceCurrency: 'USD', name: 'Team', priceSpecification: { '@type': 'UnitPriceSpecification', price: '19', priceCurrency: 'USD', billingDuration: 'P1M', unitText: 'base + $8/member' }, description: 'Everything in Pro plus screen recording, guest access, Jira, Asana, and Linear integrations' },
  ],
  featureList: 'Click-to-annotate, Visual feedback, Auto-screenshot, Threaded comments, Team collaboration, Slack integration, Jira integration, Element pinning, Type-colored markers',
});

export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Cayda',
  url: 'https://www.cayda.io',
  logo: 'https://www.cayda.io/logo512.png',
});
